class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopMedia = window.matchMedia('(min-width: 990px)');
    this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    window.addEventListener('resize', this.updateDesktopSubmenuPosition.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );

    this.updateDesktopSubmenuPosition();
  }

  handleMouseEnter() {
    if (!this.desktopMedia.matches || this.mainDetailsToggle.hasAttribute('open')) return;

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.updateDesktopSubmenuPosition();
  }

  handleMouseLeave() {
    if (!this.desktopMedia.matches || this.contains(document.activeElement)) return;

    this.close();
  }

  updateDesktopSubmenuPosition() {
    if (
      !this.desktopMedia.matches ||
      !this.content ||
      (!this.content.classList.contains('header__submenu') && !this.content.classList.contains('mega-menu__content'))
    ) {
      return;
    }

    const summaryRect = this.mainDetailsToggle.querySelector('summary').getBoundingClientRect();
    const headerRect = this.header.getBoundingClientRect();
    const left = summaryRect.left + summaryRect.width / 2;
    const top = Math.max(summaryRect.bottom - 2, headerRect.bottom - 2);
    const bridgeTop = Math.max(summaryRect.bottom - 2, headerRect.bottom - 2) - 16;

    this.content.style.setProperty('--header-submenu-left', `${left}px`);
    this.content.style.setProperty('--header-submenu-top', `${top}px`);
    this.mainDetailsToggle.style.setProperty('--header-submenu-left', `${left}px`);
    this.mainDetailsToggle.style.setProperty('--header-submenu-bridge-top', `${bridgeTop}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
